// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  eventId: __t.u64().primaryKey().name("event_id"),
  worldId: __t.u64().name("world_id"),
  settlementId: __t.u64().name("settlement_id"),
  kind: __t.string(),
  family: __t.string(),
  x: __t.f32(),
  z: __t.f32(),
  hostId: __t.u64().name("host_id"),
  title: __t.string(),
  detail: __t.string(),
  participantsJson: __t.string().name("participants_json"),
  startsAt: __t.timestamp().name("starts_at"),
  endsAt: __t.timestamp().name("ends_at"),
  phase: __t.string(),
  refId: __t.u64().name("ref_id"),
});
